export default "__VITE_ASSET__aca4e422__"